import React, { Component } from "react";
import CssClasses from "./AdminHeader.css";

import logoImg from "../../../assets/images/logo.png";

import { connect } from "react-redux";

let h, m, s;
let moment = require("moment");

class AdminHeader extends Component {
  state = {
    currentTimeFormatted: "--:--:--"
  };

  _isMounted = false;

  componentDidMount() {
    //pokreni timer za sat
    this.getCurrentTime();
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getCurrentTime() {
    this.checkTime();
    let time = h + ":" + m + ":" + s;

    let that = this;
    setTimeout(function() {
      that.getCurrentTime();
    }, 500);

    if (this._isMounted) {
      this.setState({ currentTimeFormatted: time });
    }
  }

  checkTime() {
    var today = new Date();

    //dohvati offset
    var offset = 60; //parseInt($("[id*='hfUTCOffsetMinutes']").val());

    //ako je dst, offset je 120
    if (moment().isDST()) {
      //console.log("DST");
      offset = 120;
    }

    var localOffset = today.getTimezoneOffset();
    today = moment(today)
      .add(offset + localOffset, "m")
      .toDate();

    h = today.getHours();
    m = today.getMinutes();
    s = today.getSeconds();
    if (h < 10) h = "0" + h;
    if (m < 10) m = "0" + m;
    if (s < 10) s = "0" + s;
  }

  render() {
    return (
      <div className={CssClasses.container}>
        <div className={CssClasses.leftSection}>
          <div className={CssClasses.logo}>
            <img src={logoImg} alt="" />
          </div>
        </div>
        <div className={CssClasses.rightSection}>
          <div className={CssClasses.clock}>
            {this.state.currentTimeFormatted}
          </div>
          {/* todo jezik */}
          <div className={CssClasses.userInfo}>
            Pozdrav, {this.props.adminInfo.Username}!
          </div>
        </div>
        <div className={CssClasses.clearFix} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    adminInfo: state.rrNavigation.adminInfo
  };
};

export default connect(mapStateToProps)(AdminHeader);



// WEBPACK FOOTER //
// ./src/Containers/AdminScreens/AdminHeader/AdminHeader.js